import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { InputForm } from 'controls/Input'
import { Button, Spinner } from 'controls'
import style from './style'
import setPasswordValidator from 'app/validators/setPasswordMailbox'
import { image } from 'services'

class SetMailboxPassword extends Component {
  render() {
    const { handleSubmit, confirmed, loading, errorApi } = this.props
    if (!confirmed && !loading && !errorApi) {
      return (
        <div className="password-email-container">
          <form onSubmit={handleSubmit}>
            <h3 className="disclaimer-password">
              ¿Quieres recibir los correos en tu celular?
            </h3>
            <h3 className="hideOnMobile">
              ¡Genial! Ahora ingresa tu contraseña
            </h3>
            <p>
              Ingresa una nueva contraseña para acceder al servicio de envío por
              teléfono.
            </p>
            <Field
              type="password"
              placeholder="Contraseña"
              className="form-input-margin"
              component={InputForm}
              name="firtsPassword"
              id="firtsPassword"
              required
            />
            <Field
              type="password"
              placeholder="Repite contraseña"
              className="form-input-margin"
              component={InputForm}
              name="confirmPassword"
              id="confirmPassword"
              required
            />
            <p>La contraseña debe ser alfanumérica de mínimo 8 caracteres</p>
            <Button color="primary" type="submit" fullWidth>
              Confirmar
            </Button>
          </form>
          <style jsx>{style}</style>
        </div>
      )
    }
    if (loading && !errorApi) {
      return (
        <div className="password-email-container password-loading">
          <Spinner size={50} thickness={5} style={{ margin: '20px auto' }} />
          <p>Cargando</p>
          <style jsx>{style}</style>
        </div>
      )
    }
    if (confirmed && !loading && !errorApi) {
      return (
        <div className="password-email-container password-success">
          <h4>Tu contraseña ha sido actualizada correctamente.</h4>
          <img
            src={image('icons/icono-admin-mensaje-enviado-copy.svg')}
            alt="Contraseña asignada con éxito"
          />
          <h5>Ahora podrás ver tus correos desde tu teléfono.</h5>
          <style jsx>{style}</style>
        </div>
      )
    }
    return (
      <div className="password-email-container">
        <h5>
          Lo sentimos, hubo un error, intenta más tarde con una nueva
          contraseña.
        </h5>
        <h5> Sí el problema persiste, por favor comunícate con nosotros. </h5>
        <style jsx>{style}</style>
      </div>
    )
  }
}

const formConfig = {
  form: 'passwordMailboxForm',
  validate: setPasswordValidator
}

export const ReduxSetMailboxPassword = reduxForm(formConfig)(SetMailboxPassword)

export default SetMailboxPassword
